import React, { useContext } from "react";

import { PrivateContext } from "lib/context";
import { storageHelper } from "lib/helpers";
import { Spinner } from "lib/components";
import { withErrorBoundary } from "lib/hoc";

import constant from "lib/constant/constant";

import { ProviderConsolidatedReport } from "./provider/features";
import { OperatorConsolidatedReport } from "./operator/features";

const ReportSetting = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { isLoading } = useContext(PrivateContext);
  const {
    userKey: { operator, provider },
  } = constant;

  const getComponent = (role) => {
    if (role === operator) {
      return <OperatorConsolidatedReport />;
    }
    if (role === provider) {
      return <ProviderConsolidatedReport />;
    }
    return null;
  };

  if (isLoading) {
    return <Spinner />;
  }

  const currentUserRole = storageHelper.get("userRole");
  const ConsolidatedReportingComponent = getComponent(currentUserRole);
  return ConsolidatedReportingComponent;
};

export default withErrorBoundary(ReportSetting);
